import { render, staticRenderFns } from "./CurriculumCardList.vue?vue&type=template&id=ac15e5ea&"
import script from "./CurriculumCardList.vue?vue&type=script&lang=js&"
export * from "./CurriculumCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports